import React from "react";
import { RiDiscountPercentFill } from "react-icons/ri";
import styles from "./DiscountBadge.module.css";

const DiscountBadge = ({ percent }) => {
  const value = Math.round(Number(percent) || 0);

  if (value <= 0) return null;

  return (
    <span
      className={styles.discountPercentBadge}
      aria-label={`Знижка -${value}%`}
    >
      <RiDiscountPercentFill
        className={styles.discountIcon}
        aria-hidden="true"
      />
      <span className={styles.discountPercentText}>-{value}%</span>
    </span>
  );
};

export default DiscountBadge;
